import { useState } from 'react';

import { useAppDispatch, useAppSelector, useUpdateUsername } from '@pkg/hooks';

import { updateBioChanges } from '@app/store/actions/yat-page-item-actions';

export function useHandleProfileData() {
    const [duplicateUsername, setDuplicateUsername] = useState<string | undefined>();
    const { mutateAsync: mutateUsername } = useUpdateUsername();
    const primaryYat = useAppSelector((s) => s.user?.primaryYat);
    const dispatch = useAppDispatch();

    function updateOlderPages({ eid, newUsername, newBio }: { eid?: string; newUsername?: string; newBio?: string }) {
        // for v1 and v2 pages
        dispatch(updateBioChanges({ yat: eid || '', newUsername, newBio }));
    }

    function updateBio(bio: string) {
        updateOlderPages({ eid: primaryYat, newBio: bio });
    }
    function updateUsername(username: string) {
        mutateUsername({ value: { username } }).then((r) => {
            if (!r.ok && r.error && (r.status.code == 409 || r.status.code == 422)) {
                setDuplicateUsername(username);
            }
            if (r.ok && r.value && r.value.user.username) {
                const { eid, username } = r.value.user;
                updateOlderPages({ eid, newUsername: username });
            }
        });
    }

    return { updateBio, updateUsername, duplicateUsername };
}
